export class AjaxSessionHandler {
    private handle401Callback: () => void = () => { };
    private unauthorizedRedirectUrl: string | null = null;

    constructor() {
        $(document).on("ajaxComplete", (event, xhr, settings) => {
            if (xhr.status === 401) {
                this.handle401Callback();

                if (this.unauthorizedRedirectUrl) {
                    this.redirectLocation(this.unauthorizedRedirectUrl);
                }

            }
        });
    }
    on401(callback: () => void): AjaxSessionHandler {
        this.handle401Callback = callback;
        return this;
    }
    unauthorizedRedirect(url: string): AjaxSessionHandler {
        this.unauthorizedRedirectUrl = url;
        return this;
    }

    private redirectLocation = (url: string) => {
        if (window !== window.top) {
            window.top.location.href = url;
        } else {
            window.location.href = url;
        }
    }
}